var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { RosterTemplate } from '@/models/RosterTemplate';
import ErrorHandler from '@/support/ErrorHandler';
let CreateTemplateDialog = class CreateTemplateDialog extends Vue {
    constructor() {
        super(...arguments);
        this.rosterTemplateName = '';
    }
    mounted() {
        //
    }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    create() {
        new RosterTemplate()
            .create({
            length_in_days: 7,
            start_day: this.startDay,
            title: this.rosterTemplateName,
        })
            .then((newRosterTemplate) => {
            this.$emit('rosterTemplateCreated', newRosterTemplate);
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    clear() {
        this.rosterTemplateName = '';
    }
    get startDay() {
        const startOfDay = this.$store.state.settings.find((setting) => {
            return setting.key === 'first_day_of_week';
        });
        return startOfDay ? startOfDay.value : 'monday';
    }
};
CreateTemplateDialog = __decorate([
    Component({
        components: {
        //
        },
    })
], CreateTemplateDialog);
export default CreateTemplateDialog;
